import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'flare', 'IconFlare', [["path",{"d":"M12 3l3 6l6 3l-6 3l-3 6l-3 -6l-6 -3l6 -3z","key":"svg-0"}]]);